import Entity from "lib/models/Entity";
import { computed } from "mobx";

import Creator from "./Creator";

interface RfeImageSource {
  id: number;
  file: string;
  creator: Creator;
  pdf: number;
  isComplete: boolean;
}

export default class RfeImage extends Entity<RfeImageSource> {
  @computed
  get file(): string {
    return this.source.file;
  }

  @computed
  get creator(): Creator {
    return this.source.creator;
  }

  @computed
  get pdf(): number {
    return this.source.pdf;
  }

  @computed
  get isComplete(): boolean {
    return this.source.isComplete || false;
  }

  @computed
  get title(): string {
    const split = this.source.file.split("/");
    return split[split.length - 1];
  }

  @computed
  get url(): string {
    return this.source.file.replace("media/srv/RfeAPI/deployment/", "");
  }

  public setComplete() {
    this.source.isComplete = true;
  }
}

export type { RfeImageSource };
